<template>
    <div>
        <template v-if="booking.type === 'order'">
            <span class="d-block text-capitalize">Order #: {{ booking.order_number || booking.order_id || 'N/A' }}</span>
            <span class="d-block text-capitalize">Customer: {{ booking.customer_name || 'N/A' }}</span>
            <span class="d-block d-none">Email: {{ booking.customer_email || 'N/A' }}</span>
            <span class="d-block d-none">Phone: {{ booking.customer_phone || 'N/A' }}</span>
            <span class="d-block text-capitalize">
                Address: {{ address }}
                <i class="bi bi-clipboard ms-1 cursor-pointer" 
                   @click="copyAddress" 
                   v-tooltip.top="'Copy address'"></i>
            </span>
            <span class="d-block">Postal Code: {{ booking.postal_code || 'N/A' }}</span>
            <span class="d-block">Service Time: {{ booking.service_time || (booking.start + ' - ' + booking.end) || 'N/A' }}</span>
            <span class="d-block">Services: {{ servicesList }}</span>
            <span class="d-block">Access Arrangement: {{ booking.access_arrangement || 'N/A' }}</span>
        </template>
        <template v-else-if="booking.type === 'project'">
            <span class="d-block text-capitalize">Project: {{ booking.project_name || 'N/A' }}</span>
            <span class="d-block text-capitalize">Name: {{ booking.customer_name || 'N/A' }}</span>
            <span class="d-block d-none">Email: {{ booking.customer_email || 'N/A' }}</span>
            <span class="d-block d-none">Phone: {{ booking.customer_phone || 'N/A' }}</span>
            <span class="d-block text-capitalize">
                Address: {{ address }}
                <i class="bi bi-clipboard ms-1 cursor-pointer" 
                   @click="copyAddress" 
                   v-tooltip.top="'Copy address'"></i>
            </span>
            <span class="d-block">Postal Code: {{ booking.postal_code || 'N/A' }}</span>
            <span class="d-block">Amount: {{ systemSettings.currency.symbol }}{{ booking.final_amount }}</span>
            <span class="d-block text-capitalize">Status: {{ booking.status }}</span>
            <span class="d-block">Start At: {{ formatDate(booking.start_at) }}</span>
            <span class="d-block">Ends At: {{ formatDate(booking.ends_at) }}</span>
        </template>
    </div>
</template>

<script>
import { tooltipDirective } from '../../directives/tooltip';

export default {
    name: 'PopoverContent',
    directives: {
        tooltip: tooltipDirective
    },
    props: {
        booking: {
            type: Object,
            required: true
        },
        systemSettings: {
            type: Object,
            default: () => ({ currency: { symbol: '£' } })
        },
        onCopyAddress: {
            type: Function,
            default: null
        }
    },
    computed: {
        address() {
            if (this.booking.type === 'order') {
                return this.booking.service_address || this.booking.booking_address || 'N/A';
            } else if (this.booking.type === 'project') {
                return this.booking.address || 'N/A';
            }
            return 'N/A';
        },
        servicesList() {
            if (this.booking.services && this.booking.services.length > 0) {
                return this.booking.services.map(service => service.service_name).join(', ');
            }
            return 'N/A';
        }
    },
    methods: {
        copyAddress() {
            // Call the onCopyAddress prop directly since this is a separate app instance
            if (this.onCopyAddress && typeof this.onCopyAddress === 'function') {
                this.onCopyAddress(this.address);
            }
        },
        formatDate(date) {
            if (!date) return 'N/A';
            // Use the same date format as parent
            return new Date(date).toLocaleDateString('en-GB');
        }
    }
};
</script>